import { Flow } from '@thive/fddm-types';

import { InvalidFlow } from './types';
import { validateConsolidationFlows } from './validateConsolidationFlows';
import { validateGoodsToPersonFlows } from './validateGoodsToPersonFlows';

export const validateFlows = (flows: Flow[]): InvalidFlow[] => {
  const consolidationFlows: Flow[] = [];
  const goodsToPersonFlows: Flow[] = [];
  flows.forEach((flow) => {
    if (flow.type === 'CONSOLIDATION_RETRIEVAL' || flow.type === 'CONSOLIDATION_STORAGE') {
      consolidationFlows.push(flow);
    } else if (flow.type === 'GOODS_TO_PERSONS') {
      goodsToPersonFlows.push(flow);
    }
  });

  const invalidConsolidation = validateConsolidationFlows(consolidationFlows);
  const invalidGoodsToPerson = validateGoodsToPersonFlows(goodsToPersonFlows);

  // Per flow: every flow shows its own errors, also when another flow into the same area has the same one
  const invalidFlows = [...invalidConsolidation, ...invalidGoodsToPerson].filter(
    (flow, index, self) =>
      index ===
      self.findIndex(
        (f) => f.flowId === flow.flowId && f.areaId === flow.areaId && f.reason === flow.reason,
      ),
  );
  return invalidFlows;
};
